import { AddPeriodicCheckFeedbackOutDto, AddPeriodicCheckFeedbackInDto } from '../../../types/periodic-check.dto'

export const ADD_PERIODIC_CHECK_FEEDBACK = 'ADD_PERIODIC_CHECK_FEEDBACK'
export const ADD_PERIODIC_CHECK_FEEDBACK_SUCCESS = 'ADD_PERIODIC_CHECK_FEEDBACK_SUCCESS'
export const ADD_PERIODIC_CHECK_FEEDBACK_ERROR = 'ADD_PERIODIC_CHECK_FEEDBACK_ERROR'
export const RESET_ADD_PERIODIC_CHECK_FEEDBACK = 'RESET_ADD_PERIODIC_CHECK_FEEDBACK'

export interface AddPeriodicCheckFeedback {
  type: typeof ADD_PERIODIC_CHECK_FEEDBACK
  payload: AddPeriodicCheckFeedbackOutDto
}

export interface AddPeriodicCheckFeedbackSuccess {
  type: typeof ADD_PERIODIC_CHECK_FEEDBACK_SUCCESS
  payload: AddPeriodicCheckFeedbackInDto<any>
}

export interface AddPeriodicCheckFeedbackError {
  type: typeof ADD_PERIODIC_CHECK_FEEDBACK_ERROR
  payload: string | boolean
}

export interface ResetAddPeriodicCheckFeedback {
  type: typeof RESET_ADD_PERIODIC_CHECK_FEEDBACK
  payload: null
}
export interface State {
  data: AddPeriodicCheckFeedbackInDto<any> | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = AddPeriodicCheckFeedback | AddPeriodicCheckFeedbackSuccess | AddPeriodicCheckFeedbackError | ResetAddPeriodicCheckFeedback
